// extracted by mini-css-extract-plugin
export default {"img":"ShipmentTimelineIcon_img__eNXWx","iconWrapper":"ShipmentTimelineIcon_iconWrapper__C2sDI","node":"ShipmentTimelineIcon_node__AvNRR","route":"ShipmentTimelineIcon_route__HXyZm"};